import React from 'react';
import Web3 from 'web3';
import image from './eggman2.png';

class GameDetails extends React.Component {
    state = { 
      contractDetails: {
        contract: null, 
        account: this.props.account, 
        web3: this.props.web,
      },
      gameData: {
        maxAllowedEntries: '', 
        numberOfCurrentEntries: '', 
        numberOfWinners: '', 
        costPerEntry: '',
        gameStarted: '1',
        prizeMode: '',
        rewardETHPerWinner: '',
        isLoading: true // initial loading state
      }
    };


    componentDidMount() {
        this.loadBlockchainData();
        this.intervalId = setInterval(this.loadBlockchainData, 5000); // Refresh every 2 seconds
    }

    componentDidUpdate(prevProps) {
        if (this.props.account !== prevProps.account) {
            // The account prop has changed
            // You can perform any side effect here, like fetching new data using the new account
            this.loadBlockchainData();
        }
    }
    componentWillUnmount() {
      clearInterval(this.intervalId); // Clear the interval when the component unmounts
    }

    loadBlockchainData = async () => {
    try {
        const { web3 } = this.props;
        console.log(web3);
        if (!web3) {
            console.error("Web3 is not available. Please connect your wallet or install a Dapp browser.");
            return;  // Return early if web3 is not available
        }

        web3.eth.net.getNetworkType((err, netId) => {
            if (err) {
                console.error(err);
                return;
            }

            if (netId !== "main") {
                console.log('This is not the mainnet');
                return;
            }
        })

        const accounts = await web3.eth.getAccounts();
        const account = accounts[0] ? accounts[0] : null;
        this.setState({ account, web3});

        // setup the contract
        const gameContractAddress = '0x2bdDD797FB8dFEfFcf3363481D8f2d861535549c';//'0x2bdDD797FB8dFEfFcf3363481D8f2d861535549c'; 
        const gameContractABI = require('./contractABI.json');
        const gameContract = new web3.eth.Contract(gameContractABI, gameContractAddress);
        console.log(gameContract);
        this.setState({ contract: gameContract });

        this.setState(prevState => ({
            contractDetails: {
                ...prevState.contractDetails,
                contract: gameContract
            }
        }));
        web3.eth.getBlockNumber().then(console.log);
        const maxAllowedEntries = await gameContract.methods.maxAllowedEntries().call();
        const numberOfCurrentEntries = await gameContract.methods.numberOfCurrentEntries().call();
        const numberOfWinners = await gameContract.methods.numberOfWinners().call();
       // console.log(gameContract.methods); // to check what methods are available

        const costPerEntry = await gameContract.methods.costPerEntry().call();
        const gameStarted = await gameContract.methods.gameStarted().call();
        const prizeMode = await gameContract.methods.prizeMode().call();
        const rewardETHPerWinner = await gameContract.methods.rewardETHPerWinner().call();

        let userEntries = '?';

        if(account) {
            userEntries = await gameContract.methods.getParticipantEntries(account).call();
        }

        this.setState(prevState => ({
            gameData: {
                ...prevState.gameData,
                userEntries: userEntries,
                maxAllowedEntries: maxAllowedEntries,
                numberOfCurrentEntries: numberOfCurrentEntries,
                numberOfWinners: numberOfWinners,
                costPerEntry: costPerEntry,
                gameStarted: gameStarted,
                prizeMode: prizeMode,
                rewardETHPerWinner: rewardETHPerWinner,
                isLoading: false
            }
        }));
    } catch (error) {
        console.error("Error loading blockchain data: ", error);
        this.setState(prevState => ({
            gameData: {
                ...prevState.gameData,
                isLoading: false
            }
        }));
    }
}

    render() {
        let prizeModeText = this.state.gameData.prizeMode === '0' ? "NFT" : "ETH";
        let prizeDetail = this.state.gameData.prizeMode === '0' ? "SPROTO GREMLINS NFT" : Web3.utils.fromWei(this.state.gameData.rewardETHPerWinner, 'ether') + " ETH";
        let progress = this.state.gameData.numberOfCurrentEntries / this.state.gameData.maxAllowedEntries * 100;
        let userEntry = this.state.gameData.userEntries;


        return (
            <>
                <div style={{ textAlign: 'center'}}>
                    <div className ="mainbanner" style={{ width: 'auto', height: 'auto' }}>
                        <img src={image} alt="Descriptive alt text" style={{ width: '100%', height: 'auto' }} />
                    </div>

                    {!this.props.web3 ? (
                        <div className="enterBox" style={{ backgroundColor: 'red', color: 'white', width: 'auto', height: 'auto', fontSize: '2vw', fontWeight: 'bold', padding: "1vw" }}>
                            Connect your wallet
                        </div>
                    ) : this.state.gameData.gameStarted == 0 ? (
                        <div className="enterBox" style={{ backgroundColor: 'red', color: 'white',width: 'auto', height: 'auto', fontSize: '2vw', fontWeight: 'bold', padding: '1vw' }}>
                            Game not started
                        </div>
                    ) : (
                        <>
                            <div className ="enterBox" style={{ width: 'auto', height: 'auto' }}>
                                <h2 style={{ fontSize: '2vw', fontWeight: 'bold'}}>
                                    PRICE POOL ({this.state.gameData.numberOfWinners} {this.state.gameData.numberOfWinners === 1 ? "WINNER" : "WINNERS"}):
                                </h2>
                                <h2 style={{ fontSize: '1.8vw', fontWeight: 'bold'}}>1 X SPROTO NFT + 3 X 0.1 ETH</h2> 
                                <h2 style={{ fontSize: '1.8vw', fontWeight: 'bold'}}>0.2 ETH DONATION to ZachXBT</h2> 
                             </div>
                             
                           <div className ="enterBox" style={{ width: 'auto', height: 'auto' }}>
                               <h2 style={{ fontSize: '2vw', fontWeight: 'bold'}}> ENTRY: {Web3.utils.fromWei(this.state.gameData.costPerEntry, 'ether')} ETH PER TICKET </h2> 
                           </div>

                            <div className ="enterBox" style={{ width: 'auto', height: 'auto' }}>
                                <p style={{ fontSize: '2vw', fontWeight: 'bold' }}>
                                    TICKETS BOUGHT: {this.state.gameData.numberOfCurrentEntries} / {this.state.gameData.maxAllowedEntries}
                                </p>

                                <div className="progressBar">
                                    <div className="progressBarFill" style={{width: `${progress}%`}}></div>
                                    <span className="progressText" style={{fontSize: '2vw'}}>{progress.toFixed(0)}% </span>
                                </div>                       
                                <p style={{ fontSize: '2vw', fontWeight: 'bold' }}>YOU HAVE {userEntry} TICKETS</p>
                            </div>
                        </>
                    )}
                </div>
            </>
        );

    }
}

export default GameDetails;